import { IDispatcherService, IDispatcher } from '../';
import { IAction } from '../../models';
import { IActionActionsService } from './actions.actionCreator';

export interface IActionStoreService {
    getAll: (force?: boolean) => angular.IPromise<IAction[]>;
    addOne: (action: IAction) => angular.IPromise<IAction>;
    updateOne: (action: IAction) => angular.IPromise<IAction>;
    deleteOne: (guid: string) => angular.IPromise<IAction>;
}

export interface IActionActionDispatcherService extends IDispatcherService<IActionStoreService> { }

export class ActionActionDispatcherService implements IActionActionDispatcherService {
    static serviceId = 'actionActionDispatcherService';

    static $inject = ['actionActionsService'];

    constructor(private _service: IActionActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IActionStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._service.getAll(force)),
                addOne: (action: IAction) => dispatch(this._service.addOne(action)),
                updateOne: (action: IAction) => dispatch(this._service.updateOne(action)),
                deleteOne: (guid: string) => dispatch(this._service.deleteOne(guid))
            }
        };
    }
}
